import React, { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Button } from '@whitesharx/starfall-frontend-ui-kit';

import { buttonStyles, textStyles } from './styles.css';
import { TAP_EVENTS } from '~/src/services/analytics/contants';
import { useOnboardingServices } from '~/src/components/CustomApp/OnboardingCustomApp';

export type LeaveToolProps = {
  onLeave?(): void;
  pulse?: boolean;
  loading?: boolean;
};

const LeaveTool: FC<LeaveToolProps> = ({ onLeave, pulse, loading }) => {
  const { Analytics } = useOnboardingServices();

  const onLeaveButtonClick = () => {
    Analytics.sendEvent(TAP_EVENTS.exitMatch);
    onLeave?.();
  };

  return (
    <Button
      className={buttonStyles}
      onClick={onLeaveButtonClick}
      pulse={pulse}
      blurContent={pulse}
      blockContent={pulse}
      loading={loading}
      disabled={loading}
    >
      <div className={textStyles}>{t('button.exit')}</div>
    </Button>
  );
};

export default LeaveTool;
